var _module_exports = "\n<canvas id=\"digitalGauge\"></canvas>";;
var path = '/widget/lib/agrolog/client/components/digital-gauge.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;